module.exports = __webpack_public_path__ + "img/2009 feuerwehr winteressen 003.1b913221.jpg";